import { useMemo, useState } from "react";
// MUI
import { Typography } from "@mui/material";

// Hooks
// Components
import FloatingTabButtonSelector from "@Layouts/components/FloatingTabButtonSelector/index";
import FilterRow from "@Settings/components/SystemSettings/GeneralContainer/sections/SalesLog/InitialDataFilter/FilterRow";

// Types
import type { IFilterConfiguration, ISystemSettings } from "@Settings/types/Common/model";

type InitialDataFilterArgs = {
	isLoading: boolean;
	systemSettings: ISystemSettings;
	// Callbacks
	onUpdateInitialDataFilter: (tab: string, category: string, config: IFilterConfiguration) => void;
};

export default function InitialDataFilter(props: Readonly<InitialDataFilterArgs>) {
	const { isLoading, systemSettings, onUpdateInitialDataFilter } = props;
	const { salesLogInitialDataFilter } = systemSettings;

	const tabs = useMemo(() => {
		if (!salesLogInitialDataFilter?.length) {
			return [];
		}

		return salesLogInitialDataFilter?.map((item) => item.name);
	}, [salesLogInitialDataFilter]);

	// States
	const [activeTabName, setActiveTabName] = useState(tabs[0]);

	const contents = useMemo(() => {
		return tabs.map((tab) => {
			return (
				<FilterRow
					key={tab}
					isLoading={isLoading}
					activeTabName={activeTabName}
					data={salesLogInitialDataFilter.find((item) => item.name === activeTabName)}
					// Callbacks
					onUpdateInitialDataFilter={onUpdateInitialDataFilter}
				/>
			);
		});
	}, [activeTabName, tabs, salesLogInitialDataFilter, onUpdateInitialDataFilter, isLoading]);

	return (
		<>
			<Typography component={"h2"} variant="h1">
				Initial Data Filter
			</Typography>
			<FloatingTabButtonSelector
				filterOptions={tabs}
				selectedTab={activeTabName}
				contents={contents}
				initialTab={0}
				// Callbacks
				onToggleSelected={(label) => {
					setActiveTabName(label);
				}}
			/>
		</>
	);
}
